import angular from 'angular';
import Dashboard from './dashboard/dashboard';
import ResourceList from './dashboard/list/list';
import Detail from './dashboard/detail/detail';
import DetailDescription from './dashboard/detail/description/description';
import DetailMap from './dashboard/detail/map/map';
import DetailGallery from './dashboard/detail/gallery/gallery';
import Comments from './dashboard/comments/comments';
import Users from './dashboard/users/users';
import Information from './dashboard/information/information';
import NewInformationModal from './dashboard/information/addNew/addNew';
import Login from './login/login';
import ConfirmRegistration from './confirmRegistration/confirmRegistration';

let componentModule = angular.module('app.components', [
  Dashboard,
  ResourceList,
  Detail,
  DetailDescription,
  DetailMap,
  DetailGallery,
  Comments,
  Users,
  Information,
  NewInformationModal,
  Login,
  ConfirmRegistration
])

  .name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js